export default __webpack_public_path__ + "40caf2b45c20a1522895df5ec7f369c3.wasm";